module.exports = __webpack_public_path__ + "img/PYBLogo.96468bb2.png";